import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import React from 'react';
import { toast, ToastContainer } from 'react-toastify';
import createApplication from './app/createApplication';
import { Modals } from './components';
import { PulseTheme } from './components/layout/PulseTheme';
import Routes from './routes';
import { StoreContext } from './store';

dayjs.extend(utc);

const { store } = createApplication({
  apiEndpointUrl: process.env.REACT_APP_API_URL || '',
  isDebuggingEnabled: true,
});

export default function App() {
  return (
    <React.StrictMode>
      <PulseTheme>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <StoreContext.Provider value={store}>
            <ToastContainer
              hideProgressBar
              position={toast.POSITION.BOTTOM_RIGHT}
            />
            <Modals />
            <Routes />
          </StoreContext.Provider>
        </LocalizationProvider>
      </PulseTheme>
    </React.StrictMode>
  );
}
